/**
 * Configuração centralizada do site. Edite estes valores para refletir o ambiente real.
 *
 * NOTA: SITE_URL é usada em canonical, og:url e sitemap.xml. Trocar para o domínio
 * de produção antes do deploy.
 */
export const SITE_URL = 'https://www.educalegal.com.br';

export const SITE_NAME = 'Educa Legal';
export const SITE_LEGAL_NAME = 'Educa Legal — Guimarães Neto Advogados';

export const SITE_DEFAULT_TITLE = 'Educa Legal — Jurídico para Educação';
export const SITE_DEFAULT_DESCRIPTION =
  'Assessoria jurídica especializada para escolas e instituições de ensino. Trabalhista, LGPD, contratos, compliance, M&A educacional e Reforma Tributária — em todo o Brasil.';

export const SITE_OG_IMAGE = '/foto-hero-pedro.webp';

export const WHATSAPP_NUMBER_E164 = '+5511989082892';
export const WHATSAPP_DISPLAY = '+55 11 98908-2892';
export const WHATSAPP_HREF = 'https://wa.me/5511989082892';

export const CONTACT_EMAIL = 'contato@educalegal.com.br';

export const SOCIAL = {
  instagram: 'https://instagram.com/educalegal',
  linkedin: 'https://linkedin.com/company/educalegal',
} as const;

export const OFFICES = [
  {
    city: 'São Paulo',
    state: 'SP',
    region: 'Bela Vista',
    address: 'Av. Paulista, 2537 — Bela Vista',
    streetAddress: 'Av. Paulista, 2537',
    addressLocality: 'São Paulo',
    addressRegion: 'SP',
    postalCode: '',
    addressCountry: 'BR',
  },
  {
    city: 'Belo Horizonte',
    state: 'MG',
    region: 'Belvedere',
    address: 'Rua Jornalista Djalma Andrade — Belvedere',
    streetAddress: 'Rua Jornalista Djalma Andrade',
    addressLocality: 'Belo Horizonte',
    addressRegion: 'MG',
    postalCode: '',
    addressCountry: 'BR',
  },
] as const;
